export default __webpack_public_path__ + "static/tabs-context-do-b6f0d5f8d30bc2dfedb67f9cc22ff1b2460b9f592cfbc3d2d6b3352d8a997fdd.png";